import { CTA, styled } from '@volkswagen-onehub/components-core';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { OneFormState, Option } from 'src/types';

interface wrapperProps {
	error?: boolean;
}

const CTAsWrapper = styled.div<wrapperProps>`
	margin: 0 -12px;
	& button {
		margin: 12px;
		width: auto;
		border-color: ${(props) => (props.error ? 'rgb(228, 0, 44)' : 'inherit')};
		border-width: ${(props) => (props.error ? '2px' : '1px')};
	}
`;

interface props {
	name: string;
	options: Array<Option>;
	nextOnClick?: boolean;
	required?: boolean;
}

export const RadioButtonGroup = (props: props) => {
	const { name, options, nextOnClick, required } = props;

	const { handleNextStep } = useOneFormContext();
	const dispatch = useDispatch();
	const { formData } = useSelector((state: OneFormState) => state);
	const { fields } = formData;
	const [optionValue, setOptionValue] = useState(fields[name]);
	const { register, errors, setValue } = useFormContext();

	const handleCheck = (value: string) => {
		setOptionValue(value);
		setValue(name, value);
		dispatch({ type: 'UPDATE_FIELDS', payload: { [name]: value } });

		setTimeout(() => {
			if (nextOnClick) handleNextStep();
		}, 0);
	};

	return (
		<CTAsWrapper error={errors[name] && !optionValue ? true : false}>
			{options.map((option, index) => (
				<CTA
					key={index}
					onClick={(e) => {
						e.preventDefault();
						handleCheck(option.value);
					}}
					emphasis={optionValue === option.value ? 'primary' : 'secondary'}
					tag="button"
					size="small"
				>
					{option.label}
				</CTA>
			))}
			<input
				type="hidden"
				name={name}
				value={optionValue}
				ref={register({
					required: {
						value: required ? required : false,
						message: 'Requerido',
					},
				})}
			/>
		</CTAsWrapper>
	);
};
